/**
 * Hero — front end. Attaches background videos only where they'll be seen:
 * not on phones when "Show image instead on phones" is on, and never for
 * reduced-motion users (they keep the image).
 */
( function () {
	const phone = window.matchMedia( '(max-width: 767px)' ).matches;
	const reduceMotion = window.matchMedia(
		'(prefers-reduced-motion: reduce)'
	).matches;

	document
		.querySelectorAll( '[data-deline-hero-video]' )
		.forEach( function ( video ) {
			const hasImage = !! video.parentElement.querySelector(
				'.deline-hero__image'
			);

			if (
				( phone && video.dataset.hideMobile === '1' && hasImage ) ||
				( reduceMotion && hasImage )
			) {
				video.remove();
				return;
			}

			video.addEventListener(
				'playing',
				function () {
					video.classList.add( 'is-playing' );
				},
				{ once: true }
			);

			video.src = video.dataset.src;

			if ( reduceMotion ) {
				// No image to fall back on: show the first frame, still.
				video.preload = 'metadata';
				video.classList.add( 'is-playing' );
				return;
			}

			const play = video.play();
			if ( play && play.catch ) {
				play.catch( function () {} );
			}
		} );
} )();
